import animals from './animals';

export default {
  modules: {
    animals,
  },
};
